import { ROUTES } from "../../../routes";
import { MdSearch } from "react-icons/md";
import usePageTitle from "../../../hooks/use-page-title";
import ApiProgramme from "../../../modules/api/programme";
import { Link } from "react-router-dom";
import AppUserContext from "../../../context/app-user-context";
import { useState, useContext, useEffect } from "react";
import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import ServerSideProgrammeDataTable from "../../../components/common/ServerSideProgrammeDataTable";

type TPageSelectProgrammeProps = {
  isDashboard?: boolean;
};

export default function PageSelectProgramme(props: TPageSelectProgrammeProps) {
  const title = "Home";
  usePageTitle(title);
  usePortalSettingSet("label_header", title);
  const { setCustomText } = useContext(PortalContext);
  const user = useContext(AppUserContext);
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setCustomText(null);
  }, []);

  return (
    <main className="form-generic content-generic content-generic--fluid">
      <h1 className="fs-title hide-mobile-down">Programme(s) you are administrating:</h1>

      <div className="cg__actions">
        <div className="cg__action-buttons d-none">
          <button
            className="btn btn-outline-primary d-none"
            onClick={() => setRefresh((i) => !i)}
          >
            Refresh
          </button>
        </div>
        <div className="cg__action-search">
          <span>
            <MdSearch />
          </span>
          <input
            type="text"
            placeholder="Search"
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <ServerSideProgrammeDataTable
        api={ApiProgramme.pagingSearch}
        search={search}
        columns={[
          {
            id: "name",
            name: "Name of Programme",
            sortable: true,
            maxWidth: "250px",
            selector: (row) => row.name,
            // cell: (row) => (
            //   <Link
            //     to={`${ROUTES.PORTAL_COHORTS}/${row._id}`}
            //     className="title-column"
            //   >
            //     {row.name}
            //   </Link>
            // ),
          },
          {
            id: "description",
            name: "Description",
            selector: (row) => row.description,
            sortable: true,
            cell: (row) => (
              <div className="description-column">{row.description}</div>
            ),
          },
          {
            id: "action",
            maxWidth: "170px",
            name: "",
            cell: (row) => {
              const from = props.isDashboard
                ? ROUTES.PORTAL_DASHBOARD
                : ROUTES.PORTAL_SELECT_PROGRAMME;
              return (
                <div className="manage-cohorts-link-wrapper">
                  <Link
                    to={`${ROUTES.PORTAL_COHORTS}/${row._id}`}
                    className="manage-cohorts-link"
                    state={{ from: from }}
                  >
                    Manage Cohorts
                  </Link>
                </div>
              );
            },
          },
        ]}
        refresh={refresh}
        programAdminId={user.referenceUserId}
      />
    </main>
  );
}
